import {
  parseEncasing,
  renderWebComponent,
  string2obj
} from "../../../utils/utils";


export class EncasingParserComponent extends HTMLElement {
  props = {};

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
  }

  render() {
    const html = `              
      <span>
        ${ parseEncasing(this.props.encasing, this.props.categoryName) }
      </span>
    `

    renderWebComponent(html, this.shadowRoot);
  }
}

window.customElements.define("encasing-parser-component", EncasingParserComponent);